import { useLang } from "../../landing_new/i18n";

export function LanguageSwitch() {
  const { lang, setLang } = useLang();
  const opts = ["en", "pl"];
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-background p-0.5 text-xs font-medium">
      {opts.map((o) => (
        <button
          key={o}
          type="button"
          onClick={() => setLang(o)}
          aria-pressed={lang === o}
          className={`rounded-full px-2.5 py-1 uppercase tracking-wide transition-colors ${
            lang === o ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {o}
        </button>
      ))}
    </div>
  );
}
